import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/layout/PageHeader';
import { EntitlementGate } from '@/components/gates';
import { ExportPanel } from '@/components/scout';

export const Route = createFileRoute('/scout/export')({
  component: ExportPage,
});

function ExportPage() {
  return (
    <EntitlementGate module="scout">
      <div className="space-y-6">
        <PageHeader title="Export" backTo="/scout/runs" />
        <ExportPanel />
      </div>
    </EntitlementGate>
  );
}